import * as _ from 'lodash';
import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';

import { FlashService } from '../../components/flash/flash.service';
import moment from 'moment';
import { LocationCollection } from '../location-collections';
import { LocationCollectionsService } from '../location-collections.service';

@Component({
    selector: 'app-edit-location-collection',
    templateUrl: './edit.component.html',
    styleUrls: ['./edit.component.scss'],
    standalone: false
})
export class EditLocationCollectionComponent implements OnInit {
  locationCollection: LocationCollection;
  isEdit = false;

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private locationCollectionsService: LocationCollectionsService,
    private flashService: FlashService
  ) {
  }

  ngOnInit() {
    this.route.data.subscribe(data => {
      const locationCollection = data.locationCollection.location_collection;
      this.locationCollection = new LocationCollection();
      this.locationCollection.id = locationCollection.id;
      this.locationCollection.name = locationCollection.name;
      this.locationCollection['created_on'] = moment(locationCollection['created_at']).format('LLL');
      this.locationCollection['updated_on'] = moment(locationCollection['updated_at']).format('LLL');
    });
  }

  showFlashMessage(type: string, message: string){
    this.flashService.add({
      type: type,
      message: message
    });
  }

  toggleEdit(): void {
    this.isEdit = !this.isEdit;
  }

  update(): void {
    this.locationCollectionsService.update(this.constructLocationCollectionRequest()).subscribe(() => {
      this.showFlashMessage("success", `${this.locationCollection.name} has been updated.`)
      this.isEdit = false;
    })
  }

  delete(): void {
    this.locationCollectionsService.delete(this.locationCollection.id).subscribe(() => {
      this.router.navigate(['/locations']);
      this.showFlashMessage("success", `${this.locationCollection.name} has been deleted.`)
    })
  }

  constructLocationCollectionRequest(): any {
    return {
      id: this.locationCollection.id,
      name: this.locationCollection.name
    }
  }
}

